import React from 'react';
import {Dropdown} from '../styles';
import {Space, Avatar} from 'antd';
import PageOverlayADM from "./PageOverlayADM";
import {DownCircleOutlined, MenuUnfoldOutlined} from '@ant-design/icons';
const PageMenuADM: React.FC = () => {
  return (
    <Dropdown
      overlay={(
        <PageOverlayADM
        />
      )}
    >
      <Space>
        <MenuUnfoldOutlined style={{color:'black', fontSize:'20px'}}/>
      </Space>
    </Dropdown>
  );
};

export default PageMenuADM;
